export type GetDeploymentRequestRequest = {
  dplymntReqSeq: string;
};
